import Dashboard from "layouts/dashboard";
import Leads from "layouts/leads";
import Profile from "layouts/configuracao";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import ResetPassword from "layouts/authentication/reset-password";
import ForgotPassword from "layouts/authentication/forgot-password";
import UpdatePassword from "layouts/authentication/update-password";
import Subscribe from "layouts/subscribe"; // Import the new Subscribe component
import DeployControl from "layouts/deploy";

import { IoRocketSharp, IoSettingsSharp } from "react-icons/io5";
import { IoIosDocument } from "react-icons/io";
import { BsFillPersonFill } from "react-icons/bs";
import { IoBuild } from "react-icons/io5";
import { BsCreditCardFill } from "react-icons/bs";
import { IoStatsChart } from "react-icons/io5";
import { IoHome } from "react-icons/io5";
import DossierDetail from "layouts/dossier";

const allowedDeployHosts = ["gs.saferdock.com", "localhost", "localhost:3000"];
const isDeployHost =
  typeof window !== "undefined" ? allowedDeployHosts.includes(window.location.host) : false;

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <IoHome size="15px" color="inherit" />,
    element: <Dashboard />,
    noCollapse: true,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Leads",
    key: "leads",
    route: "/leads",
    icon: <IoStatsChart size="15px" color="inherit" />,
    element: <Leads />,
    noCollapse: true,
    isPrivate: true,
  },
  {
    type: "route",
    key: "dossier-detail",
    route: "/dossier/by-fingerprint/:fingerprint",
    element: <DossierDetail />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Configuração",
    key: "configuracao",
    route: "/configuracao",
    icon: <IoSettingsSharp size="15px" color="inherit" />,
    element: <Profile />,
    noCollapse: true,
    isPrivate: true,
  },
  {
    type: "route",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    icon: <IoIosDocument size="15px" color="inherit" />,
    element: <SignIn />,
    noCollapse: true,
  },
  {
    type: "route",
    name: "Sign Up",
    key: "sign-up",
    route: "/authentication/sign-up",
    icon: <IoRocketSharp size="15px" color="inherit" />,
    element: <SignUp />,
    noCollapse: true,
  },
  {
    type: "route",
    name: "Update Password",
    key: "update-password",
    route: "/authentication/update-password", // Rota para a nova página
    icon: <IoRocketSharp size="15px" color="inherit" />,
    element: <UpdatePassword />,
    noCollapse: true,
  },
  {
    type: "route",
    name: "Forgot Password",
    key: "forgot-password",
    route: "/authentication/forgot-password",
    icon: <IoRocketSharp size="15px" color="inherit" />,
    element: <ForgotPassword />,
    noCollapse: true,
  },
  {
    type: "route",
    name: "Subscribe",
    key: "subscribe",
    route: "/subscribe",
    element: <Subscribe />,
    noCollapse: true,
  },
];

if (isDeployHost) {
  routes.splice(4, 0, {
    type: "collapse",
    name: "Deploy",
    key: "deploy",
    route: "/deploy",
    icon: <IoBuild size="15px" color="inherit" />,
    element: <DeployControl />,
    noCollapse: true,
    isPrivate: true,
  });
}

export default routes;
